import "./lib/moment";
import Sortable from "sortablejs";

window.Sortable = Sortable;
